module.exports = __webpack_public_path__ + "img/sjdt-gyldsj.8f968036.png";